// extracted by mini-css-extract-plugin
module.exports = {"root":"buttons-block_root__2owDY","items":"buttons-block_items__sagf_","button":"buttons-block_button___C2oL","container":"buttons-block_container__tCX2V"};